@let order = pickingOrder();
@let userId = this.userId();

<div class="flex flex-row items-center gap-2">
  <div class="flex flex-row justify-center items-center w-6">
    @if (order.anwender?.id && userId !== order.anwender?.id) {
      <soft-icon name="fa-regular fa-lock"></soft-icon>
    } @else if (order.retoure) {
      <soft-icon name="fa-regular fa-turn-left"></soft-icon>
    } @else if (order.mischpalette) {
      <soft-icon name="fa-regular fa-pallet-boxes"></soft-icon>
    } @else {
      <soft-icon name="fa-regular fa-hand-holding-box"></soft-icon>
    }
  </div>

  <div class="flex flex-col w-full">
    <div class="flex flex-row gap-2 w-full text-xs">
      <div class="flex flex-row w-full gap-2 flex-wrap-reverse">
        @if (order?.kzbezahlt === 'J') {
          <soft-icon
            name="fa-solid fa-dollar-circle text-success-600 text-sm -mr-1"
          ></soft-icon>
        }

        <div class="text-xs text-light">
          @if (order?.lagerplatzAuswahl) {
            {{ '#KOMMISSIONIERUNG.PAGES.AUFTRAG_AUSWAHL.LAGERPLATZ_AUSWAHL' | translate }}
          } @else {
            {{
              '#KOMMISSIONIERUNG.PAGES.AUFTRAG_AUSWAHL.KEINE_LAGERPLATZ_AUSWAHL'
                | translate
            }}
          }

          @if (order?.lieferart_bezeichnung | isDefinedNotEmpty) {
            <span>| {{ order.lieferart_bezeichnung }}</span>
          }
        </div>
        @if (order.retoure) {
          <span
            class="flex flex-row gap-1 items-center bg-warning rounded-full px-2 text-warning-contrast w-fit"
          >
            <soft-icon name="fa-regular fa-turn-left" class="fa-xs"></soft-icon>
            Retoure
          </span>
        }
        @if (order?.mischpalette === true) {
          <span
            class="flex flex-row gap-1 items-center bg-warning rounded-full px-2 text-warning-contrast w-fit"
          >
            <soft-icon name="fa-regular fa-pallet-boxes" class="fa-xs"></soft-icon>
            Mischpalette
          </span>
        }
      </div>
      @if (order.anwender?.id && userId === order.anwender?.id) {
        <span
          class="flex flex-row gap-1 items-center bg-success rounded-full px-2 text-success-contrast w-fit min-h-4 shrink-0"
        >
          <soft-icon name="fa-regular fa-user" class="fa-xs"></soft-icon>
          {{ order.anwender?.anwender }}
        </span>
      } @else if (order.anwender?.id) {
        <span
          class="flex flex-row gap-1 items-center bg-danger rounded-full px-2 text-danger-contrast w-fit min-h-4 shrink-0"
        >
          <soft-icon name="fa-regular fa-lock" class="fa-xs"></soft-icon>
          {{ order.anwender?.anwender }}
        </span>
      }
    </div>

    <div class="flex items-center gap-1">
      <div class="text-xl font-semibold">
        {{
          (order.retoure
            ? '#KOMMISSIONIERUNG.PAGES.AUFTRAG_AUSWAHL.RETOURE'
            : '#KOMMISSIONIERUNG.PAGES.AUFTRAG_AUSWAHL.ART.' +
              (order.lieferart | uppercase)
          ) | translate
        }}
        {{ order.belegnummer }}
      </div>
      @if (
        (order?.abholdatum | isDefinedNotEmpty) ||
        (order?.lieferdatum | isDefinedNotEmpty)
      ) {
        <div class="text-xl">
          ({{ order?.abholdatum || order?.lieferdatum | format: 'DATE.DEFAULT' }})
        </div>
      }
    </div>

    <div class="flex gap-1 text-base text-light">
      {{ belegart() }} {{ order?.belegnummer_auftrag }}
      @if (order?.vertreter_kurzbez | isDefinedNotEmpty) {
        <span>(Vertreter: {{ order.vertreter_kurzbez }})</span>
      }
    </div>
    <div class="color-light text-sm">{{ order.kunde.name }}</div>
    @if ((order.kommtext | isDefined) && order.kommtext !== '') {
      <div
        class="flex flex-row mt-1 items-center"
      >
        <i class="fa-regular fa-circle-info"></i>
        <div class="w-full ml-2">{{ order.kommtext }}</div>
      </div>
    }

    @if (order?.lieferhinweis | isDefinedNotEmpty) {
      <div class="flex flex-row gap-2 mt-1 items-center">
        <i class="fa-regular fa-truck-fast text-primary"></i>
        <div class="truncate text-sm text-light max-w-[70vw]">
          {{ order?.lieferhinweis }}
        </div>
      </div>
    }
  </div>
</div>
